const veeCustomMessage = {
  fr: {
    attributes: {
      last_name: 'nom',
      first_name: 'prénom',
      email: 'mail',
      mobile_phone: 'téléphone mobile',
      password: 'mot de passe',
      password_confirmation: 'mot de passe',
      occupations: 'métier',
      affiliated_service: "Service de rattachement",
      services: 'service',
      replaced_occupation: 'métier concerné par la demande de remplacement',
      searched_occupations: 'métier(s) recherché(s)',
      replaced_service: 'pour le service',
      entityCode: 'code d\'établissement',
      job_presentation: 'présentation du poste',
      searched_profile: 'profil recherché'
    },
    messages: {
      mobile_phone: "Ce numéro n'est pas un numéro français valide.",
      affiliated_service: "Le service de rattachement doit faire partie des services de remplacement.",
      email_taken: "Cet email est déjà pris"
    },
    custom: {
      password_confirmation: {
        confirmed: 'Les mots de passe ne sont pas identiques.',
        required: 'Veuillez confirmer le mot de passe.',
      },
      acceptCGU: {
        required: "Vous devez accepter les CGU."
      }
    }
  }
};

export default veeCustomMessage;



// WEBPACK FOOTER //
// ./src/lang/veeCustom.js